export default "__VITE_ASSET__119b2ba5__"